<template>
  <div
    v-show="model"
    class="lg:z-[100] bg-semantic-surface-container-lowest shadow-lg w-full h-auto xl:hidden block"
  >
    <div class="flex flex-col">
      <div v-for="(item, index) in menu" :key="index">
        <div
          class="flex-row cursor-pointer bg-semantic-surface-container-low text-semantic-inverse-on-primary font-bold"
          @click.stop="setCurrentMenu(item)"
        >
          <div class="flex justify-between items-center px-6 py-2 h-16">
            <span
              :class="{
                'text-semantic-primary-default': getActiveCurrentMenu(item),
              }"
            >
              {{ item.title }}
            </span>

            <V2IconsCaret
              class="w-4 h-4"
              :direction="getActiveCurrentMenu(item) ? 'top' : 'bottom'"
              :fill="
                getActiveCurrentMenu(item)
                  ? semanticColorLookup('primary.default')
                  : semanticColorLookup('surface.on-surface')
              "
            />
          </div>

          <div
            v-if="getActiveCurrentMenu(item)"
            class="bg-semantic-primary-on-light flex flex-col gap-[1px]"
          >
            <template
              v-for="(menuItem, menuIndex) in item.menu"
              :key="menuIndex"
            >
              <NuxtLink
                :to="menuItem.url"
                class="flex gap-2 items-center px-8 py-4 bg-semantic-surface-container-lowest"
                @click="model = false"
              >
                <span>
                  {{ menuItem.title }}
                </span>

                <V2IconsArrow
                  class="w-4 h-4"
                  direction="right"
                  :fill="semanticColorLookup('surface.on-surface')"
                />
              </NuxtLink>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'V2OrganismNavBarMegaMenuMobile'
})

defineProps({
  menu: {
    type: Array,
    default: () => []
  }
})

const model = defineModel({
  type: Boolean,
  default: false
})

const currMenu = ref()
const setCurrentMenu = item => {
  if (currMenu.value?.title !== item?.title) {
    currMenu.value = item
    return
  } 

  currMenu.value = null
}
const getActiveCurrentMenu = item => {
  return currMenu.value?.slug === item.slug
}

watch(model, () => {
  currMenu.value = null
})
</script>
